module.exports = __webpack_public_path__ + "static/logo-c7359725715b7b4bf7088cc812c6b262.svg";